import { render, staticRenderFns } from "./LevyPaymentChangeLog.vue?vue&type=template&id=446e2f5e&"
import script from "./LevyPaymentChangeLog.vue?vue&type=script&lang=js&"
export * from "./LevyPaymentChangeLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports